<template>
  <!-- Note: not in use anymore because it's going through app.vue now -->
  <!-- <TairoSidebarLayout> -->
  <slot />
  <!-- </TairoSidebarLayout> -->
</template>
